import { Navigate } from "react-router";
import type { ReactNode } from "react";
import { useAuth } from "../lib/auth-context.js";
import { LoadingScreen } from "./loading-screen.js";

/**
 * Wraps a route that should only be visible to unauthenticated users
 * (sign-in, sign-up). Already-authed users get bounced to the dashboard
 * to avoid the "sign-in form behind your existing session" UX trap.
 */
export function PublicOnlyRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === "loading") return <LoadingScreen label="Loading…" />;
  if (status === "auth") return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
